import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  createCommand,
  LexicalCommand,
  COMMAND_PRIORITY_NORMAL,
  $getRoot,
  $getSelection,
} from 'lexical';
import { useEffect } from 'react';
import { $createAttachmentNode } from '../../customNodes';

export const INSERT_ATTACHMENT_COMMAND: LexicalCommand<{
  id: string;
  reference: string;
}> = createCommand();

export const AttachmentPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_ATTACHMENT_COMMAND,
      ({ id, reference }) => {
        editor.update(() => {
          const attachmentNode = $createAttachmentNode(id, reference);
          // The citation is already on the impression; without its footnote
          // in the text, save prunes it. Never drop the insert.
          const selection = $getSelection() ?? $getRoot().selectEnd();
          selection.insertNodes([attachmentNode]);
        });
        return true;
      },
      COMMAND_PRIORITY_NORMAL,
    );
  }, [editor]);

  return null;
};
